import React, { Component } from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import Customer from './Customer';
import IssueComplaint from '../components/IssueComplaint/IssueComplaint';
import Error from './Error';
import CreateComplaintMenu from '../components/CreateComplaintMenu/CreateComplaintMenu';
import ComplaintPositions from '../components/ComplaintPositions/ComplaintPositions';
import PostComplaintIssueWindow from './PostComplaintIssueWindow';
import MenageComplaintPosition from '../components/MenageComplaintPosition/MenageComplaintPosition';
import SingleComplaintPosition from '../components/MenageComplaintPosition/SingleComplaintPosition';

class CreateComplaint extends Component {

    render() {
        return (
            <div className="col-xs-12">
                {(this.props.showWindowPicker) &&
                <CreateComplaintMenu /> }
                <Error />
                {this.props.currentPage === "Customer" && <Customer />}
                {this.props.currentPage === "ComplaintPositions" && <ComplaintPositions />} 
                {this.props.currentPage === "SingleComplaintPosition" && <SingleComplaintPosition/>}
                {this.props.currentPage === "Preview" && <IssueComplaint />}
                {this.props.currentPage === "IssueComplete" && <PostComplaintIssueWindow />}
                {this.props.currentPage === "ComplaintPosition" && <MenageComplaintPosition />}
            </div>
        );
   }
}

CreateComplaint.propTypes = {
    getCustomersTypes: PropTypes.func,
    currentPage: PropTypes.string,
    showWindowPicker:PropTypes.bool
};

const mapStateToProps = (state) => {
  return{
    currentPage:state.page.window,
    showWindowPicker:state.page.showWindowPicker
  };
};



export default withRouter(connect(mapStateToProps, null)(CreateComplaint));


// WEBPACK FOOTER //
// ./src/containers/CreateComplaint.js